import { render, staticRenderFns } from "./SessionUserSelector.vue?vue&type=template&id=4f19825f&scoped=true&"
import script from "./SessionUserSelector.vue?vue&type=script&lang=js&"
export * from "./SessionUserSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f19825f",
  null
  
)

export default component.exports